/* eslint-disable import/prefer-default-export */

import { SET_LANGUAGE } from "../actionTypes";

export const setLanguage = (languageCode) => {
  return (dispatch) => {
    dispatch({ type: SET_LANGUAGE, payload: languageCode });
  };
};
